import React from 'react';

const UserGuideLink = () => {
  const handleGuideClick = () => {
    // Open the user guide in a new tab
    window.open('/user-guide.html', '_blank');
  };

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-5">
      <div className="flex flex-col sm:flex-row sm:items-start">
        <div className="flex-shrink-0 mb-3 sm:mb-0 sm:mt-1">
          <svg className="h-6 w-6 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-0 sm:ml-4 flex-1">
          <p className="text-base text-blue-700 mb-4 sm:mb-0">
            <strong>New to the Employee Update Manager?</strong> Check out our user guide for detailed instructions.
          </p>
          <div className="flex justify-start sm:justify-end">
            <button
              onClick={handleGuideClick}
              className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 btn-mobile"
            >
              View Guide
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserGuideLink;